import axios from 'axios';
import ServerProperties from '../../config/server.js'
import {RequestinProcess,AddPaginationURL} from '../../helper/request.action.js'

export default {
  Register: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API+'Asset/Tracking/Register/',
      {
        AssetAlias:params.data.AssetAlias,
        SiteAlias : params.data.SiteAlias,
        LocationAlias : params.data.LocationAlias,
        DueDate : params.data.DueDate=== undefined?null:params.data.DueDate.format('YYYY-MM-DD'),
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response)
    });
  },
  Update: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Asset/Tracking/Update/'+params.data.Alias+'/',
      {
        AssetAlias:params.data.AssetAlias,
        SiteAlias : params.data.SiteAlias,
        LocationAlias : params.data.LocationAlias,
        DueDate : params.data.DueDate.format('YYYY-MM-DD'),
      }
    )
    .then(function (response) {
      // console.log(response);
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Delete: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'Asset/Tracking/Delete/'+params.data.Alias+'/',
      {
        AssetAlias:'',
        SiteAlias : '',
        LocationAlias :'',
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Read: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'Asset/Trackings/'+params.data.AssetAlias+'/?search='+params.data.query+'&ordering='+params.data.ordering: params.data.url,
      {
      }
    )
    .then(function (response) {
      // console.log(response);
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:response.data.next,previous:response.data.previous,rs:response.data.results,query:params.data.query}))
      params.onsuccess(params, response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:null,previous:null,rs:[],query:''}))
      try {
        // console.log(error);
        // params.onfailed(error.response.details)
      }
      catch(error) {
        console.log(error);
        // expected output: SyntaxError: unterminated string literal
        // Note - error messages will vary depending on browser
      }

    });
  },
  ReadAll: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'Asset/Trackings/?&ordering='+params.data.ordering: params.data.url,
      {
      }
    )
    .then(function (response) {
      params.onsuccess(params, response)
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{
        next:response.data.next,
        previous:response.data.previous,
        rs:response.data.results,
        query:params.data.query
      }))
    })
    // .catch(function (error) {
    //   params.RunRedux(RequestinProcess({in_process:false,type:null}))
    //   params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:null,previous:null,rs:[],query:''}))
    //   params.onfailed(error)
    // });
  },
  ReadByAsset: function(params){
    // console.log(params)
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'Asset/Trackings/'+params.data.query+'/?search=&ordering='+params.data.ordering: params.data.url,
      {
      }
    )
    .then(function (response) {
      // console.log(response);
      params.onsuccess(params, response)
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:response.data.next,previous:response.data.previous,rs:response.data.results,query:params.data.query}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:null,previous:null,rs:[],query:''}))
      if(error.response.hasOwnProperty('details')) {
        params.onfailed(error.response.details)
      }

    });
  },
  ReadByFilter: function(params){
    // console.log(params.self)
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ? ServerProperties.ATM_CLOUD.API+'Asset/Trackings-Filter/'+params.data.query+'/?filter='+params.self.props.match.params.Filter+'&ordering='+params.data.ordering: params.data.url,
      {
      }
    )
    .then(function (response) {
      // console.log(response);
      params.onsuccess(params, response)
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:response.data.next,previous:response.data.previous,rs:response.data.results,query:params.data.query}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("AssetTrackingSetRS",{next:null,previous:null,rs:[],query:''}))
      params.onfailed(error.response.details)
    });
  },
}



// WEBPACK FOOTER //
// ./src/App/asset/tracking/model.js